import moment from "moment";
import React, { useEffect, useState } from "react";
import { IoCopyOutline } from "react-icons/io5";
import { TbFileDownload } from "react-icons/tb";
import AOCodeListDialogWrapper from "src/components/AOCodeListDialog/AOCodeListDialogWrapper";
import ATMCopyToClipboard from "src/components/UI/atoms/ATMCopyToClipboard/ATMCopyToClipboard";
import ATMImageZoomer from "src/components/UI/atoms/ATMImageZoomer/ATMImageZoomer";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import { useDeleteZipFileMutation } from "src/services/AdminServices";
import {
  useChangePANStatusMutation,
  useDeletePanExtraFileMutation,
  useSetPanTempRemarkMutation,
  useGetPanZipMutation,
  useLazyGetPanFormByPanIdQuery,
  useSkipPANFormFillMutation,
  useUploadPanExtraFileMutation,
} from "src/services/PANService";
import AddMoreFileDialog, {
  StaffFileRow,
} from "./Dialog/AddMoreFileDialogBox/AddMoreFileDialog";
import TempRemarkDialog from "./Dialog/AddMoreFileDialogBox/TempRemarkDialog";
import OldPanFormsDialog from "./Dialog/OldPanFormsDialog";
import {
  canManageStaffFiles,
  STAFF_FILE_UPLOAD_FOLDER,
} from "./Dialog/AddMoreFileDialogBox/staffFileRules";
import { MdDelete } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import AuthHOC from "src/userAccess/AuthHOC";
import { AccessAction } from "src/utils/Enums/AccessAction";
import { showToast } from "src/utils/toaster/showToast";
import { useParams } from "react-router-dom";
import { showConfirmationDialog } from "src/utils/showConfirmationDialog";
import Swal from "sweetalert2";
import ApplicationRejectionDialogWrapper from "src/components/ApplicationRejectionDialog/ApplicationRejectionDialogWrapper";
import ApplicationVerifyDialogWrapper from "src/components/ApplicationVerifyDialog/ApplicationVerifyDialogWrapper";
import Tooltip from "@mui/material/Tooltip";
import { EmployerCertificateUpdateListResponse } from "src/models/EmployerCertificateUpdate.model";
import DownloadDialogWrapper from "src/pages/employer-certificate/list/Dialog/DownloadDialogBox/DownloadDialogWrapper";
import { isEmployerCertificateCategory } from "src/pages/employer-certificate/employerCertificateCategories";
import { useLazyGetemployerCertificateDoneApplicationByIdQuery } from "src/services/EmployerCertificateService";
import { AffidavitCertificateUpdateListResponse } from "src/models/AffidavitCertificateUpdate.model";
import AffidavitDownloadDialogWrapper from "src/pages/affidavit-certificate/list/Dialog/DownloadDialogBox/DownloadDialogWrapper";
import { useLazyGetaffidavitCertificateDoneApplicationByIdQuery } from "src/services/AffidavitCertificateService";
import {
  ackFileBaseName,
  downloadFileAs,
  downloadImageOnWhite,
  PAN_PHOTO_SPEC,
  PAN_SIG_SPEC,
} from "src/utils/downloadFileAs";

type Props = {
  applicationData: any;
};

// Section Heading
const SectionHeading = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="border-l-[3px] border-primary-main px-3 py-2 text-slate-700 font-medium text-[15px] ">
      {children}
    </div>
  );
};

// Field
const InfoField = ({
  label,
  value,
  accessField,
}: {
  label: string;
  value: string;
  accessField?: string;
}) => {
  const [isCopied, setIsCopied] = React.useState(false);
 
  if (accessField) {
    return (
      <AuthHOC moduleName="PAN_APPLICATIONS" type="FIELD" field={accessField}>
        <div>
          <div className=" font-medium text-primary-main text-sm">
            {" "}
            {label}{" "}
          </div>
        {label && (
        <div
          className={`p-2 flex justify-between items-center rounded mt-1 text-sm ${
            label.toLowerCase().includes("Mother's Name")
              ? "bg-gray-300"
              : "bg-stone-100"
          }`}
        >
          <span
            className={`${
              label.toLowerCase().includes("Mother's Name")
                ? "font-bold text-red-700"
                : ""
            }`}
          >
            {value || "N/A"}
          </span>
          <ATMCopyToClipboard
            tooltipTitle={isCopied ? "Copied" : "Copy"}
            copyText={value}
            onCopy={() => {
              setIsCopied(true);
              setTimeout(() => {
                setIsCopied(false);
              }, 1000);
            }}
          >
            <IoCopyOutline />
          </ATMCopyToClipboard>
        </div>
      )}

        </div>
      </AuthHOC>
    );
  }

  return (
     console.log(label,"label", value, "val", accessField,  label?.toLowerCase().includes("mother's name".toLowerCase())
),
    <div>
      <div className=" font-medium text-primary-main text-sm"> {label} </div>
       {label && (
        <div
          className={`p-2 flex justify-between items-center rounded mt-1 text-sm ${
            label?.toLowerCase().includes("mother's name".toLowerCase())

              ? "bg-gray-300"
              : "bg-stone-100"
          }`}
        >
          <span
            className={`${
              label?.toLowerCase().includes("mother's name".toLowerCase())

                ? "font-bold text-red-700"
                : ""
            }`}
          >
            {value || "N/A"}
          </span>
          <ATMCopyToClipboard
            tooltipTitle={isCopied ? "Copied" : "Copy"}
            copyText={value}
            onCopy={() => {
              setIsCopied(true);
              setTimeout(() => {
                setIsCopied(false);
              }, 1000);
            }}
          >
            <IoCopyOutline />
          </ATMCopyToClipboard>
        </div>
      )}
    </div>
  );
};

// Document Card
const DocumentCard = ({
  title,
  imageUrl,
}: {
  title: string;
  imageUrl: string;
}) => {
  return (
    <Tooltip title="Click to Zoom">
      <div
        // data-lg-size={1400}
        data-src={imageUrl}
        className="rounded p-3 border border-black cursor-zoom-in hover:opacity-50 transition-all"
      >
        <div className="text-primary-main text-sm font-medium">{title}</div>
        <div className="mt-2">
          <img src={imageUrl} className="w-full h-[150px] rounded" alt="" />
        </div>
      </div>
    </Tooltip>
  );
};

/**
 * Marks the picture inside a StaffFileCard as a lightgallery item.
 *
 * A class rather than the card itself, because the card also holds a delete
 * button — see the `selector` note on ATMImageZoomer.
 */
const STAFF_FILE_ZOOM_CLASS = "staff-file-zoom";

/**
 * A file a staff member attached from this page after verify.
 *
 * Kept separate from DocumentCard rather than bolted onto it: this one carries
 * the upload audit and a delete action, and a PDF entry has to render as a link
 * rather than an <img> — an <img> pointed at a PDF just draws a broken icon.
 *
 * An image opens in the SAME lightgallery viewer as every other document on
 * this page — full size, with the filmstrip, rotate, flip and zoom. Only the
 * picture is the trigger (`STAFF_FILE_ZOOM_CLASS`, handed to the zoomer as its
 * `selector`), so the delete button and the remark sit outside it and a click
 * on delete does not also open the viewer. A PDF carries no trigger at all and
 * stays a plain "Open PDF" link.
 */
const StaffFileCard = ({
  file,
  onDelete,
  isDeleting,
}: {
  file: any;
  onDelete?: (file: any) => void;
  isDeleting: boolean;
}) => {
  const isImage = file?.mimeCategory !== "PDF";
  return (
    <div className="rounded p-3 border border-primary-main flex flex-col">
      <div className="flex items-start justify-between gap-2">
        <div className="text-primary-main text-sm font-medium break-words">
          {file?.title || "Attached File"}
        </div>
        {onDelete && (
          <button
            type="button"
            title="Remove this file"
            disabled={isDeleting}
            onClick={() => onDelete(file)}
            className="text-red-500 shrink-0 disabled:opacity-40"
          >
            <MdDelete size={18} />
          </button>
        )}
      </div>

      {isImage ? (
        <Tooltip title="Click to Zoom">
          {/* The lightgallery item. `data-src` is the full-size file it opens
              and `data-sub-html` the caption under it, the same two attributes
              DocumentCard relies on. */}
          <div
            className={`${STAFF_FILE_ZOOM_CLASS} mt-2 cursor-zoom-in hover:opacity-50 transition-all`}
            data-src={file?.fileUrl}
            data-sub-html={file?.title || ""}
          >
            <img
              src={file?.fileUrl}
              className="w-full h-[150px] rounded object-cover"
              alt={file?.title || ""}
            />
          </div>
        </Tooltip>
      ) : (
        <a href={file?.fileUrl} target="_blank" rel="noreferrer" className="mt-2">
          <div className="w-full h-[150px] rounded bg-slate-100 flex flex-col items-center justify-center text-slate-600">
            <TbFileDownload size={34} />
            <span className="text-[12px] mt-1">Open PDF</span>
          </div>
        </a>
      )}

      {file?.uploaded_file_remark && (
        <Tooltip title={file.uploaded_file_remark}>
          {/* Clamped inline rather than with `line-clamp-2`: those utilities
              are a plugin on Tailwind 3.2 and this project loads none, so the
              class would be a no-op and a long remark would stretch the card. */}
          <div
            className="mt-2 text-[12px] text-slate-700 overflow-hidden"
            style={{
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
            }}
          >
            {file.uploaded_file_remark}
          </div>
        </Tooltip>
      )}

      <div className="mt-2 text-[11px] text-slate-500">
        <div>By {file?.uploaded_file_staff_name || "N/A"}</div>
        <div>{file?.uploaded_file_at || ""}</div>
      </div>
    </div>
  );
};

const ViewPanCardApplication = ({ applicationData }: Props) => {
  const { panApplicationId } = useParams();
  const [isOpenAOCodeDialog, setIsOpenAOCodeDialog] = React.useState(false);
  const [isZipDownloading, setIAsZipDownloading] = React.useState(false);
  const [isOpenVerifyDialog, setIsOpenVerifyDialog] = useState(false);
  const [isOpenOldPanForms, setIsOpenOldPanForms] = useState(false);
  /**
   * Ticked on FORM_FILL_PENDING to reveal the SKIP button. Two deliberate steps,
   * because skipping sends the application to print without a filled form.
   */
  const [isSkippingFormFill, setIsSkippingFormFill] = useState(false);
  const [panIdVerfiy, setPanIdVerfiy] = useState("");
  const [isOpenRejectionDialog, setIsOpenRejectionDialog] = useState(false);
  const [panIdReject, setPanIdReject] = useState("");
  const navigate = useNavigate();
  const [downloadZip] = useGetPanZipMutation();
  const [deleteZipFile] = useDeleteZipFileMutation();
  const [changeStatus] = useChangePANStatusMutation();
  const [skipFormFill] = useSkipPANFormFillMutation();

  /*
    Extra files attached by staff after verify. Live at every status from
    FORM_FILL_PENDING through DONE — canManageStaffFiles holds the same statuses
    the API enforces, so the button is hidden exactly when the call would be refused.
    Already-attached files stay visible at every status; only adding and
    removing closes.
  */
  const [isOpenAddFileDialog, setIsOpenAddFileDialog] = useState(false);
  const [uploadExtraFile, uploadExtraFileInfo] = useUploadPanExtraFileMutation();
  const [deleteExtraFile, deleteExtraFileInfo] = useDeletePanExtraFileMutation();

  const canEditStaffFiles = canManageStaffFiles(applicationData?.status);
  const staffFiles = Array.isArray(applicationData?.uploadedFiles)
    ? applicationData.uploadedFiles.filter((file: any) => file && !file.isDeleted)
    : [];

  /*
    The "document still needed" note. Raised by whoever spots the gap, read by
    the next assignee, cleared by whoever attaches the file — so it has to be
    writable with no file present, and clearing is a separate deliberate act
    rather than a side effect of uploading.
  */
  const [isOpenTempRemarkDialog, setIsOpenTempRemarkDialog] = useState(false);
  const [setTempRemark, setTempRemarkInfo] = useSetPanTempRemarkMutation();
  const tempRemark = applicationData?.tempRemark || "";

  /** Returns an error message, or null on success. */
  const handleSaveTempRemark = async (remark: string) => {
    const res: any = await setTempRemark({
      panId: applicationData?._id || "",
      remark,
    });
    if (res?.error) {
      return res?.error?.data?.message || "Could not save the remark.";
    }
    if (!res?.data?.status) {
      return res?.data?.message || "Could not save the remark.";
    }
    showToast("success", res?.data?.message);
    return null;
  };

  const handleClearTempRemark = () => {
    showConfirmationDialog({
      title: "Clear remark",
      text: "Clear this temporary remark? Do this once the document it asks for has been attached.",
      showCancelButton: true,
      next: (result: any) => {
        if (!result.isConfirmed) {
          return;
        }
        // An empty remark is what clears it — see setTempRemark in pan.service.
        setTempRemark({ panId: applicationData?._id || "", remark: "" }).then(
          (res: any) => {
            if (res?.error) {
              showToast("error", res?.error?.data?.message);
            } else if (res?.data?.status) {
              showToast("success", res?.data?.message);
            } else {
              showToast("error", res?.data?.message);
            }
          }
        );
      },
    });
  };

  /** Returns an error message, or null when the row was accepted. */
  const handleUploadStaffFile = async (row: StaffFileRow) => {
    const formData = new FormData();
    // `fileType` is read by the upload middleware to pick the folder, so it has
    // to be appended BEFORE the file — multer reads the fields in order.
    formData.append("fileType", STAFF_FILE_UPLOAD_FOLDER);
    formData.append("panId", applicationData?._id || "");
    formData.append("title", row.title.trim());
    formData.append("remark", row.remark.trim());
    formData.append("document", row.file as File);

    const res: any = await uploadExtraFile(formData);
    if (res?.error) {
      return res?.error?.data?.message || "Upload failed.";
    }
    if (!res?.data?.status) {
      return res?.data?.message || "Upload failed.";
    }
    return null;
  };

  const handleDeleteStaffFile = (file: any) => {
    showConfirmationDialog({
      title: "Remove file",
      text: `Remove "${file?.title || "this file"}"? This cannot be undone.`,
      showCancelButton: true,
      next: (result: any) => {
        if (!result.isConfirmed) {
          return;
        }
        deleteExtraFile({
          panId: applicationData?._id || "",
          fileId: file?.fileId,
        }).then((res: any) => {
          if (res?.error) {
            showToast("error", res?.error?.data?.message);
          } else if (res?.data?.status) {
            showToast("success", res?.data?.message);
          } else {
            showToast("error", res?.data?.message);
          }
        });
      },
    });
  };

  const documentsList =
    applicationData?.applicationType === "NEW"
      ? [
          {
            title: "Aadhar Card Front",
            imageUrl: applicationData?.adhaarFrontPhotoUrl,
          },
          {
            title: "Aadhar Card Back",
            imageUrl: applicationData?.adhaarBackPhotoUrl,
          },
          {
            title: "PAN Form Front",
            imageUrl: applicationData?.panFormFrontPhotoUrl,
          },
          {
            title: "PAN Form Back  ",
            imageUrl: applicationData?.panFormBackPhotoUrl,
          },
          {
            title: "Passport Photo",
            imageUrl: applicationData?.passportPhotoUrl,
          },
          {
            title: "Signature",
            imageUrl: applicationData?.signaturePhotoUrl,
          },
        ].concat(
          Array.isArray(applicationData?.otherDocuments)
            ? applicationData?.otherDocuments?.map((document: any) => {
                return {
                  title: document.title || "Other Document",
                  imageUrl: document.imageUrl,
                };
              })
            : []
        )
      : [
          {
            title: "Aadhar Card Front",
            imageUrl: applicationData?.adhaarFrontPhotoUrl,
          },
          {
            title: "Aadhar Card Back",
            imageUrl: applicationData?.adhaarBackPhotoUrl,
          },
          {
            title: "PAN Form Front",
            imageUrl: applicationData?.panFormFrontPhotoUrl,
          },
          {
            title: "PAN CARD FRONT  ",
            imageUrl: applicationData?.panCardFront,
          },
          {
            title: "Passport Photo",
            imageUrl: applicationData?.passportPhotoUrl,
          },
          {
            title: "Signature",
            imageUrl: applicationData?.signaturePhotoUrl,
          },
        ].concat(
          Array.isArray(applicationData?.otherDocuments)
            ? applicationData?.otherDocuments?.map((document: any) => {
                return {
                  title: document.title || "Other Document",
                  imageUrl: document.imageUrl,
                };
              })
            : []
        );

  // Download Zip
  const handleDownloadZip = (srn: string) => {
    setIAsZipDownloading(true);
    downloadZip(srn).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
        setIAsZipDownloading(false);
      } else {
        if (res?.data?.status) {
          let a = document.createElement("a");
          a.href = res?.data?.data;
          a.click();
          showToast("success", res?.data?.message);
          setIAsZipDownloading(false);
          deleteZipFile({
            folderUrl: res?.data?.data,
          });
        } else {
          showToast("error", res?.data?.message);
          setIAsZipDownloading(false);
        }
      }
    });
  } 

  /*
    Every PAN download is named after the acknowledgement number:
    `<ack>.pdf` for the PAN form, `<ack>_Photo`, `<ack>_Sig`, `<ack>_Affidavit`
    and `<ack>_Employer_Certificate` for the rest.
  */
  const ackNumber: string = applicationData?.acknowledgementNumber || "";

  /*
    The photo / signature as edited in the PAN form (saved on "Next: Preview")
    when there is one, otherwise the applicant's own upload.
  */
  const photoForDownload =
    applicationData?.editedPhotoUrl || applicationData?.passportPhotoUrl || "";
  const signatureForDownload =
    applicationData?.editedSignatureUrl ||
    applicationData?.signaturePhotoUrl ||
    "";

  const downloadNamed = async (url: string, suffix: string, fallbackExt = "") => {
    const ok = await downloadFileAs(
      url,
      ackFileBaseName(ackNumber, suffix, applicationData?.srn || "download"),
      fallbackExt
    );
    if (!ok) showToast("error", "Could not download the file.");
  };

   const handleDownload = () => {
    if (rowData?.employerertificateFile) {
      downloadNamed(rowData?.employerertificateFile, "Employer_Certificate", "pdf");
    } else {
      console.error("File URL is missing.");
    }
  };

  const handleAffidavitDownload = () => {
    if (affidavitRowData?.affidavitcertificatesData?.affidavitertificateFile) {
      downloadNamed(
        affidavitRowData.affidavitcertificatesData.affidavitertificateFile,
        "Affidavit",
        "pdf"
      );
    } else if (affidavitRowData?.affidavitertificateFile) {
      downloadNamed(affidavitRowData.affidavitertificateFile, "Affidavit", "pdf");
    } else {
      console.error("Affidavit file URL is missing.");
    }
  };

  /** The generated PAN form, saved as just `<ack>.pdf`. */
  const downloadPanForm = (url: string) => downloadNamed(url, "", "pdf");


const [
  getEmployerCertificateById,
  { data, isFetching, isLoading, isError, error },
] = useLazyGetemployerCertificateDoneApplicationByIdQuery();

const [
  getAffidavitCertificateById,
  { data: affidavitData, isFetching: affidavitIsFetching, isLoading: affidavitIsLoading, isError: affidavitIsError, error: affidavitError },
] = useLazyGetaffidavitCertificateDoneApplicationByIdQuery();

// PAN form record for this application — used to decide direct-download vs generate
const [getPanFormByPanId, { data: panFormData }] = useLazyGetPanFormByPanIdQuery();

useEffect(() => {
  if (!applicationData?._id) return;

  console.log("Fetching certificate for:", applicationData._id);
  getEmployerCertificateById(applicationData._id);
  getAffidavitCertificateById(applicationData._id);
  getPanFormByPanId(applicationData._id);
}, [applicationData?._id]);


// Log data whenever it changes
useEffect(() => {
  if (data) {
    console.log("API Response:", data);
    setRowData(data.data);
  }
}, [data]);

// Log affidavit data whenever it changes
useEffect(() => {
  if (affidavitData) {
    setAffidavitRowData(affidavitData.data);
  }
}, [affidavitData]);

// Optional: log errors
useEffect(() => {
  if (isError) {
    console.error("API Error:", error);
  }
}, [isError, error]);
  //   const {
  //   data,
  //   isFetching,
  //   isLoading,
  // } = useGetemployerCertificateDoneApplicationByIdQuery(
  //   applicationData?._id ?? "",
  //   {
  //     skip: !applicationData?._id,
  //   }
  // );


  const [isOpenDonwloadDialog, setIsOpenDownloadDialog] = useState(false);
  const [isOpenAffidavitDownloadDialog, setIsOpenAffidavitDownloadDialog] = useState(false);
  const [isAffidavitUpdate, setIsAffidavitUpdate] = useState(false);

  const [rowData, setRowData] = useState<EmployerCertificateUpdateListResponse | null>(null);
  const [affidavitRowData, setAffidavitRowData] = useState<AffidavitCertificateUpdateListResponse | null>(null);

  /**
   * Move the application to `nextStatus` after a confirmation. Used by the two
   * form-fill steps, which are plain status changes — no acknowledgement number
   * and no PDF, unlike VERIFY.
   */
  const moveToStatus = (
    nextStatus: string,
    confirmText: string,
    redirectTo: string
  ) =>
    showConfirmationDialog({
      title: "Heads Up",
      text: confirmText,
      icon: "question",
      showCancelButton: true,
      next: (result) => {
        if (result.isConfirmed) {
          const formData = new FormData();
          formData.append("requestedStatus", nextStatus);

          changeStatus({
            id: panApplicationId || "",
            body: formData,
          }).then((res: any) => {
            if (res.error) {
              showToast("error", res.error.data?.message);
            } else {
              if (res.data?.status) {
                showToast("success", res.data?.message);
                navigate(redirectTo);
              } else {
                showToast("error", res.data?.message);
              }
            }
          });
        }
      },
    });

 /**
  * The remark / acknowledgement-PDF panel only makes sense once the application
  * has actually been logged in. Since the flow reorder that is the VERIFY step
  * off IN_PROGRESS, so FORM_FILL_IN_PROGRESS sits *after* login and the
  * form-fill operator can pull up the login receipt while filling the form.
  * FORM_FILL_PENDING stays out: nothing there needs the receipt yet.
  */
  const hasAcknowledgementStage = ![
    "PENDING",
    "REJECT",
    "IN_PROGRESS",
    "FORM_FILL_PENDING",
    "CANCELLED",
  ].includes(applicationData?.status);

  /**
   * The login receipt, on the other hand, is offered on EVERY status once it
   * exists.
   *
   * It used to ride along inside the AO-code panel above, so an application that
   * moved on to a status outside `hasAcknowledgementStage` — or was rejected or
   * cancelled after login — hid a receipt that had already been uploaded, and
   * the operator had no way to pull it up. The file is what it is regardless of
   * where the application currently sits, so the only condition is that one was
   * uploaded.
   */
  const receiptPdf = applicationData?.acknowledgementPdf || "";

  /** "DLC / W / 123 / 4" — the four Part D cells, as they read on the form. */
  const aoCodeText = [
    applicationData?.aoAreaCode,
    applicationData?.aoType,
    applicationData?.aoRangeCode,
    applicationData?.aoNo,
  ].every((part) => part === undefined || part === null || part === "")
    ? ""
    : [
        applicationData?.aoAreaCode,
        applicationData?.aoType,
        applicationData?.aoRangeCode,
        applicationData?.aoNo,
      ]
        .map((part) => (part === undefined || part === null || part === "" ? "-" : part))
        .join(" / ");

 // Check payment category for application
  const CheckPaymentCategory = (array: any, category: string) => {
    return array?.some((item: any) => item?.code === category);
  };

  /**
   * A form-fill bypass (/pan-app/skip-form-fill) carries the application
   * straight past both form-fill steps, so no PDF is ever generated for it. The
   * bottom-right download button is hidden for those — offering it would only
   * ever land on "No PAN form has been generated". The file check covers the
   * same ground for anything else that reached VERIFY without a form.
   */
  const generatedPanForm =
    panFormData?.data?.panFormFile || applicationData?.panFormFile || "";

  /**
   * Open the PAN form for this application in its own popup window.
   * `refill` reopens an already generated form with its saved values
   * (REFILL PAN FORM); generating it again makes a new PDF and keeps the old one.
   * `refillType` is the form type picked for the refill (Form 49A / Correction).
   */
  const openPanFormWindow = (
    refill = false,
    refillType?: "NEW" | "CORRECTION"
  ) => {
    /*
      A window of its own, not a navigation: the operator
      copies name, parents, DOB and address off this page
      while typing them into the form, so this page has to
      stay open behind it. `noopener` is left off on purpose —
      the form page reads window.opener to know it can close
      itself on cancel.

      Opened as a popup sized to the whole screen, so the form
      gets a chrome-less window carrying nothing but the one
      application: a plain tab would still sit inside the
      admin's own nav and search. The window is NAMED after
      the application, so a second click on FILL PAN FORM
      raises the window already open for it instead of piling
      up duplicates of the same half-filled form. Browsers
      that refuse the popup fall back to a normal tab, which
      `window.open` returning null tells us.
    */
    const url = `/pan/${panApplicationId}/pan-form${
      refill ? `?mode=refill${refillType ? `&type=${refillType}` : ""}` : ""
    }`;
    const width = window.screen.availWidth;
    const height = window.screen.availHeight;
    const win = window.open(
      url,
      `pan-form-${panApplicationId}`,
      `popup=yes,width=${width},height=${height},left=0,top=0,resizable=yes,scrollbars=yes`
    );
    if (win) {
      // A popup re-used by name keeps its old size; a fresh
      // one can be trimmed by the browser. Either way, ask
      // for the whole screen and bring it forward.
      try {
        win.moveTo(0, 0);
        win.resizeTo(width, height);
      } catch {
        // Some browsers refuse to move/resize a window they
        // did not size themselves. The form is usable anyway.
      }
      win.focus();
    } else {
      window.open(url, "_blank");
    }
  };

  /*
    The form filler's note for this operator.

    Read from the PAN application first — that is where the API writes it and
    where it belongs. The PanForm record is the fallback: the admin also mirrors
    the remark into the saved `formData`, which every build of the API stores,
    so the note still shows on a server whose API predates the field.
  */
  const formFillRemark: string =
    applicationData?.formFillRemark ||
    panFormData?.data?.formData?.formFillRemark ||
    "";
  const wasFormFillSkipped = Boolean(
    applicationData?.formFillSkippedById || applicationData?.formFillSkippedOnDate
  );
  const canDownloadPanForm = Boolean(generatedPanForm) && !wasFormFillSkipped;
  return (
    <div className="px-5 grow overflow-auto relative ">
      <div className="rounded border p-3 2xl:h-full xl:h-full lg:h-full md:h-full shadow flex flex-col gap-3">
        {applicationData?.status === "REJECT" && (
          <div className="grid md:grid-cols-3 xs:grid-cols-1">
            <InfoField
              label="Rejection Reason"
              value={applicationData?.rejectionReason}
              accessField="email"
            />
          </div>
        )}

        <div>
          <InfoField
            label="Comment"
            value={applicationData?.comments || "N/A"}
          />
        </div>
        {/*
          The form filler's remark, for whoever generates and prints.

          Typed in the Form Fill header (PanFormDialog) and saved by
          /pan-form/add. It sits directly above the AO Code / Download Receipt /
          Find AO Codes row because that is the row this operator acts on — the
          note has to be read BEFORE the receipt is pulled or the codes are
          looked up, not found underneath them.

          Rendered only when there is one: an empty red box on every other
          application would train the eye to skip exactly this banner. Red and
          bold is the point — it is a warning from the previous operator, and
          `whitespace-pre-wrap` keeps a multi-line note readable instead of
          running it into one line.
        */}
        {formFillRemark ? (
          <div
            className="border-2 border-red-600 bg-red-50 rounded px-4 py-3 flex items-center justify-center text-center text-red-600 whitespace-pre-wrap break-words"
            /*
              Sized and weighted to be unmissable: this is the previous
              operator's warning and it has to be read before the receipt is
              pulled. `minHeight` gives it a band of its own rather than a line
              that reads like another label, and the weight is set explicitly at
              700 rather than left to a utility class.
            */
            style={{ fontWeight: 700, fontSize: "16px", minHeight: "56px" }}
          >
            {formFillRemark}
          </div>
        ) : null}

        {/*
          The open document request — "this file is still missing".

          Sits here, beside the Comment and the form filler's remark, because it
          is the same kind of thing: a note from one operator to the next, which
          has to be read BEFORE any work is done on the application, not found
          further down beside the documents.

          Shown at EVERY status, not only the two where it can be edited. A note
          left behind on an application that has moved on is exactly what someone
          needs to see. Rendered only when there is one — an empty band on every
          other application would train the eye to skip this one.
        */}
        {tempRemark ? (
          <div className="border-2 border-amber-500 bg-amber-50 rounded px-4 py-3">
            <div className="flex items-start justify-between gap-3">
              <div className="grow">
                <div className="text-[12px] font-semibold text-amber-700">
                  TEMPORARY REMARK — DOCUMENT REQUESTED
                </div>
                <div
                  className="mt-1 text-slate-800 whitespace-pre-wrap break-words"
                  style={{ fontWeight: 600, fontSize: "15px" }}
                >
                  {tempRemark}
                </div>
                <div className="mt-1 text-[11px] text-slate-500">
                  By {applicationData?.tempRemark_staff_name || "N/A"}
                  {applicationData?.tempRemark_at
                    ? ` · ${applicationData.tempRemark_at}`
                    : ""}
                </div>
              </div>

              {canEditStaffFiles && (
                <AuthHOC
                  moduleName="PAN_APPLICATIONS"
                  action={AccessAction.PAN_TEMP_REMARK}
                >
                  <div className="flex items-center gap-3 shrink-0">
                    <button
                      type="button"
                      disabled={setTempRemarkInfo?.isLoading}
                      onClick={() => setIsOpenTempRemarkDialog(true)}
                      className="text-[12px] text-primary-main underline disabled:opacity-40"
                    >
                      Edit
                    </button>
                    <button
                      type="button"
                      disabled={setTempRemarkInfo?.isLoading}
                      onClick={handleClearTempRemark}
                      className="text-[12px] text-red-600 underline disabled:opacity-40"
                    >
                      Clear
                    </button>
                  </div>
                </AuthHOC>
              )}
            </div>
          </div>
        ) : null}

        {/* Find AO Code Button */}
        <div
          className={`flex ${
            hasAcknowledgementStage ||
            receiptPdf ||
            photoForDownload ||
            signatureForDownload
              ? "justify-between"
              : "justify-end"
          } gap-2  items-stretch border-b border-slate-300 pb-2`}
        >
          {(hasAcknowledgementStage ||
            receiptPdf ||
            photoForDownload ||
            signatureForDownload) && (
              <div className="grow flex flex-wrap gap-2">
                {hasAcknowledgementStage && (
                  // Capped: the code is a short "BPL / W / 51 / 1", and a
                  // full-width box pushed the buttons beside it off to the end.
                  <div className="w-full max-w-xs">
                    <div className=" font-medium text-primary-main text-sm">
                      AO Code
                    </div>
                    {/*
                      Captured at login in place of the old remark, and what the
                      PAN form's Part D cells are pre-filled from. Applications
                      logged in before the change carry a remark and no code, so
                      that is shown instead of an empty row.
                    */}
                    <div className="bg-stone-100 p-2 flex justify-between items-center rounded mt-1 text-sm">
                      {aoCodeText || applicationData?.remark || "N/A"}
                    </div>
                  </div>
                )}
                {/*
                  Guarded on the file itself, and on nothing else: applications
                  logged in before the flow reorder reach FORM_FILL_IN_PROGRESS
                  with no receipt, and an empty href reloads the page instead of
                  downloading. Anything that HAS one shows the button, whatever
                  status it is sitting on.
                */}
                {receiptPdf && (
                  <div className="flex items-end  ">
                    <button className="p-2 border border-secondary-main rounded h-[37px] flex items-center">
                      <a
                        href={receiptPdf}
                        rel="noreferrer"
                        target="_blank"
                        className="text-secondary-main font-medium text-sm"
                      >
                        Download Receipt
                      </a>
                    </button>
                  </div>
                )}
                {/*
                  Photo and signature saved as `<ack>_Photo` / `<ack>_Sig` —
                  the copy edited in the PAN form if one was saved, else the
                  applicant's upload. Kept off the document cards because those
                  are lightgallery items: a button inside one would open the
                  viewer as well.
                */}
                {photoForDownload && (
                  <div className="flex items-end">
                    <Tooltip
                      title={
                        applicationData?.editedPhotoUrl
                          ? "Edited photo from the PAN form"
                          : "Applicant's uploaded photo"
                      }
                    >
                      <button
                        type="button"
                        onClick={async () => {
                          // 204 x 204, 200 DPI, at most 9 KB.
                          const ok = await downloadImageOnWhite(
                            photoForDownload,
                            ackFileBaseName(ackNumber, "Photo", applicationData?.srn || "download"),
                            PAN_PHOTO_SPEC
                          );
                          if (!ok) showToast("error", "Could not download the file.");
                        }}
                        className="p-2 h-[37px] text-sm font-medium border border-secondary-main text-secondary-main rounded flex items-center gap-1"
                      >
                        <TbFileDownload /> Download Photo
                      </button>
                    </Tooltip>
                  </div>
                )}
                {signatureForDownload && (
                  <div className="flex items-end">
                    <Tooltip
                      title={
                        applicationData?.editedSignatureUrl
                          ? "Edited signature from the PAN form"
                          : "Applicant's uploaded signature"
                      }
                    >
                      <button
                        type="button"
                        onClick={async () => {
                          // On white: the edited copy is a transparent PNG.
                          // At most 333 x 137, 200 DPI, at most 7 KB.
                          const ok = await downloadImageOnWhite(
                            signatureForDownload,
                            ackFileBaseName(ackNumber, "Sig", applicationData?.srn || "download"),
                            PAN_SIG_SPEC
                          );
                          if (!ok) showToast("error", "Could not download the file.");
                        }}
                        className="p-2 h-[37px] text-sm font-medium border border-secondary-main text-secondary-main rounded flex items-center gap-1"
                      >
                        <TbFileDownload /> Download Signature
                      </button>
                    </Tooltip>
                  </div>
                )}
              </div>
            )}

          <div className="flex items-end">
            <AuthHOC moduleName="CITY_CODES" action={AccessAction.LIST}>
              <ATMLoadingButton
                onClick={() => setIsOpenAOCodeDialog(true)}
                className="p-2 rounded"
              >
                Find AO Codes
              </ATMLoadingButton>
            </AuthHOC>
          </div>
        </div>

        <div className="flex flex-col gap-3 overflow-auto ">
          {/* Personal Information */}
          <div className="py-3 flex flex-col gap-3 border-t border-slate-500 ">
            <SectionHeading> PERSONAL INFORMATION iiii </SectionHeading>

            <div className="grid 2xl:grid-cols-3 xl:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 xs:grid-cols-1 gap-6 p-3">
              {/* Form 93 §15 / correction Q10. Records predating the field fall
                  back to the legacy `parentType`. Shown first so the operator
                  knows whose name gets printed before reading the parent names. */}
              <InfoField
                label="Name Printed on Card"
                value={
                  (applicationData?.printParentType ||
                    applicationData?.parentType) === "MOTHER"
                    ? "Mother"
                    : "Father"
                }
              />
              <InfoField
                label="Name"
                value={applicationData?.name}
                accessField="name"
              />
              {/* Single Parent is no longer offered on the forms, so the flag is
                  surfaced only when set — i.e. on legacy applications, where it
                  tells the operator only one parent's name was ever captured. */}
              {applicationData?.isSingleParent && (
                <div>
                  <div className="font-medium text-primary-main text-sm">Single Parent</div>
                  <div className="p-2 flex justify-between items-center rounded mt-1 text-sm bg-red-100 border border-red-400">
                    <span className="font-bold text-red-700">Yes</span>
                  </div>
                </div>
              )}

              {/* Both parents' names are always shown. On legacy single-parent
                  records the one captured name lives in `parentName`, tagged by
                  `parentType`, so recover it into the matching row. */}
              <InfoField
                label="Father's Name"
                value={
                  applicationData?.fatherName ||
                  (applicationData?.parentType === "FATHER"
                    ? applicationData?.parentName
                    : "") ||
                  "N/A"
                }
              />
              <InfoField
                label="Mother's Name"
                value={
                  applicationData?.motherName ||
                  (applicationData?.parentType === "MOTHER"
                    ? applicationData?.parentName
                    : "") ||
                  "N/A"
                }
              />
              <InfoField
                label="Date of Birth (DOB)"
                value={moment(applicationData?.dob, "yyyy-MM-DD").format(
                  "DD-MM-yyyy"
                )}
              />
              <InfoField
                label="Mobile Number"
                value={applicationData?.mobileNumber}
                accessField="mobileNumber"
              />
              <InfoField
                label="Email"
                value={applicationData?.email}
                accessField="email"
              />
              <InfoField
                label="Aadhar Number"
                value={applicationData?.adhaarNumber}
              />
            </div>
          </div>


            {/* DOB Proof Section */}
          <div
            className="py-3 flex flex-col gap-3 border-t border-slate-500"
            style={
              applicationData?.dobProofType === "AFFIDAVIT (CATEGORY 03 ₹100)" &&
              applicationData?.dobProofDocumentRequired === false
                ? {
                    padding: "15px 10px",
                    background: "#ffecb2",
                    border: "2px solid #e67325",
                    borderRadius: "5px",
                  }
                : undefined
            }
          >
            <SectionHeading> DOB PROOF </SectionHeading>
            <div className="grid 2xl:grid-cols-3 xl:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 xs:grid-cols-1 gap-6 p-3">
              <InfoField
                label="DOB Proof Type"
                value={applicationData?.dobProofType || "N/A"}
              />
              <InfoField
                label="Document Required"
                value={
                  applicationData?.dobProofDocumentRequired === false ? "No" : "Yes"
                }
              />
              {/* <InfoField
                label="Extra Charge Applied"
                value={
                  applicationData?.dobProofExtraCharge > 0
                    ? `Rs. ${applicationData?.dobProofExtraCharge}`
                    : applicationData?.dobProofType?.match(/₹(\d+)/)?.[1]
                    ? `Rs. ${applicationData.dobProofType.match(/₹(\d+)/)[1]}`
                    : "No"
                }
              /> */}
            </div>
            {/* Multiple DOB Proof Documents */}
            {applicationData?.dobProofDocuments && applicationData?.dobProofDocuments.length > 0 ? (
              <div className="p-3">
                <ATMImageZoomer>
                  {/* <div className="grid 2xl:grid-cols-3 xl:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 xs:grid-cols-1 gap-6"> */}
                    {applicationData.dobProofDocuments.map((docUrl: string, index: number) => (
                      docUrl && docUrl !== "" && (
                        <DocumentCard
                          key={index}
                          title={`DOB Proof Document ${index + 1}`}
                          imageUrl={docUrl}
                        />
                      )
                    ))}
                  {/* </div> */}
                </ATMImageZoomer>
              </div>
            ) : (
              /* Backward compatibility: show old single document field */
              applicationData?.dobProofDocument && applicationData?.dobProofDocument !== "" && (
                <div className="p-3">
                  <ATMImageZoomer>
                    <DocumentCard
                      title="DOB Proof Document"
                      imageUrl={applicationData?.dobProofDocument}
                    />
                  </ATMImageZoomer>
                </div>
              )
            )}
          </div>

          {/* Documents */}
          <div
            className={`py-3 flex flex-col gap-3  ${
              applicationData?.status !== "GENERATE" && "border-t"
            } border-slate-500`}
          >
            <div className="flex items-center justify-between gap-3 pr-3">
              <SectionHeading> DOCUMENTS </SectionHeading>

              {/*
                Only while the application is being worked on after verify. The
                API refuses the call outside those two statuses whatever the
                role holds, so hiding the button here just saves the round trip.
              */}
              <div className="flex items-center gap-2">
                {canEditStaffFiles && !tempRemark && (
                  <AuthHOC
                    moduleName="PAN_APPLICATIONS"
                    action={AccessAction.PAN_TEMP_REMARK}
                  >
                    <button
                      type="button"
                      onClick={() => setIsOpenTempRemarkDialog(true)}
                      className="px-4 py-1.5 text-sm border border-primary-main text-primary-main rounded"
                    >
                      Add Temporary Remark
                    </button>
                  </AuthHOC>
                )}

                {canEditStaffFiles && (
                  <AuthHOC
                    moduleName="PAN_APPLICATIONS"
                    action={AccessAction.UPLOAD_PAN_EXTRA_FILE}
                  >
                    <ATMLoadingButton
                      onClick={() => setIsOpenAddFileDialog(true)}
                      className="px-4 py-1.5 text-sm"
                    >
                      Add More File
                    </ATMLoadingButton>
                  </AuthHOC>
                )}
              </div>
            </div>


            <ATMImageZoomer>
              {documentsList.map((document, documentIndex) => (
                <DocumentCard
                  key={documentIndex}
                  title={document.title}
                  imageUrl={document.imageUrl}
                />
              ))}
            </ATMImageZoomer>

            {/*
              Attached files keep their own grid — they carry an uploader, a
              timestamp, a remark and a delete action that the plain document
              cards have no room for — but they get their own zoomer, so the
              preview opens exactly like every other document on this page.
              A separate gallery rather than the one above because the cards
              are not the items: `selector` points at the picture inside each.

              They stay visible at every status; only adding and removing is
              gated.
            */}
            {staffFiles.length > 0 && (
              <div className="px-3">
                <div className="text-[13px] font-medium text-slate-600 mb-2">
                  Attached Files
                </div>
                {/*
                  No grid of our own in here. `.lg-react-element` — the div the
                  zoomer renders — is forced to a 4-column grid by index.css,
                  so ONE wrapper child would take a single column and squeeze
                  every card into a quarter of it. The cards are the grid items,
                  exactly as the document cards above are. AuthHOC renders its
                  children with no element of its own, so it does not get in the
                  way of that.
                */}
                <ATMImageZoomer selector={`.${STAFF_FILE_ZOOM_CLASS}`}>
                  {staffFiles.map((file: any) => (
                    <AuthHOC
                      key={file?.fileId}
                      moduleName="PAN_APPLICATIONS"
                      action={AccessAction.DELETE_PAN_EXTRA_FILE}
                      // `alt` is what AuthHOC renders without the action — the
                      // card itself, minus the delete button.
                      alt={<StaffFileCard file={file} isDeleting={false} />}
                    >
                      <StaffFileCard
                        file={file}
                        onDelete={
                          canEditStaffFiles ? handleDeleteStaffFile : undefined
                        }
                        isDeleting={deleteExtraFileInfo?.isLoading}
                      />
                    </AuthHOC>
                  ))}
                </ATMImageZoomer>
              </div>
            )}
          </div>

          {isOpenAddFileDialog && (
            <AddMoreFileDialog
              onClose={() => setIsOpenAddFileDialog(false)}
              onUploadRow={handleUploadStaffFile}
              isUploading={uploadExtraFileInfo?.isLoading}
            />
          )}

          {isOpenTempRemarkDialog && (
            <TempRemarkDialog
              initialRemark={tempRemark}
              onClose={() => setIsOpenTempRemarkDialog(false)}
              onSave={handleSaveTempRemark}
              isSaving={setTempRemarkInfo?.isLoading}
            />
          )}

        

          {/* Other Information */}
          <div className="pt-3 flex flex-col gap-3 border-t border-slate-500">
            <SectionHeading> OTHER INFORMATION</SectionHeading>
            <div className="grid 2xl:grid-cols-3 xl:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 xs:grid-cols-1 gap-5 p-3">
              <InfoField
                label="Applied By"
                value={applicationData?.appliedAsType || "N/A"}
              />
              <InfoField
                label="Applied By Number"
                value={applicationData?.appliedByNumber || "N/A"}
              />
            </div>

            {applicationData?.appliedByType === "DISTRIBUTOR" &&
              applicationData?.baseCatAppied === "CAT_DSA" && (
                <div className="grid 2xl:grid-cols-3 xl:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 xs:grid-cols-1 gap-5 p-3">
                  <InfoField
                    label="Distributor Code"
                    value={applicationData?.distributorCode || "N/A"}
                  />
                  <InfoField
                    label="Distributor Name"
                    value={applicationData?.appliedByName || "N/A"}
                  />
                  <InfoField
                    label="Distributor Mobile No."
                    value={applicationData?.appliedByNumber || "N/A"}
                  />
                  <InfoField
                    label="Distributor PAN No."
                    value={applicationData?.appliedByUserPanNumber || "N/A"}
                  />
                  <InfoField
                    label="Firm Name"
                    value={applicationData?.appliedByUserFirmName || "N/A"}
                  />
                  <div>
                    <InfoField
                      label="Address"
                      value={
                        applicationData?.appliedByUserCurrentAddress || "N/A"
                      }
                    />
                  </div>
                </div>
              )}

            {applicationData?.appliedAsType === "RETAILER" &&
             (CheckPaymentCategory(applicationData?.paymentCategory ,"CAT_DSA" ) || applicationData?.baseCatAppied === 'CAT_DSA' ) && (
                <div className="grid 2xl:grid-cols-3 xl:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 xs:grid-cols-1 gap-5 p-3">
                  <InfoField
                    label="Distributor Code"
                    value={applicationData?.distributorCode || "N/A"}
                  />
                  <InfoField
                    label="Retailer Name"
                    value={applicationData?.retailerName || "N/A"}
                  />
                  <InfoField
                    label="Retailer Mobile No."
                    value={applicationData?.retailerMobileNumber || "N/A"}
                  />
                  <InfoField
                    label="Retailer PAN No."
                    value={applicationData?.retailerPanNumber || "N/A"}
                  />
                  <InfoField
                    label="Firm Name"
                    value={applicationData?.retailerFirmName || "N/A"}
                  />
                  <div>
                    <InfoField
                      label="Address"
                      value={
                        applicationData?.appliedByUserCurrentAddress || "N/A"
                      }
                    />
                  </div>
                </div>
              )}

            <div className=" flex flex-col  ">
              {applicationData?.status === "DONE" && (
                <div className="grid 2xl:grid-cols-3 xl:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 xs:grid-cols-1 gap-5 p-3">
                  <InfoField
                    label="Generated By"
                    value={applicationData?.generatedByName}
                    accessField="generatedByName"
                  />
                  <InfoField
                    label="Verified By"
                    value={applicationData?.verifiedByName}
                    accessField="verifiedByName"
                  />
                  <InfoField
                    label="Form Filled By"
                    value={applicationData?.formFilledByName}
                    accessField="formFilledByName"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        {/* Action Buttons */}
        <div className="flex gap-2 justify-center items-center sticky bottom-0">
          {/*
            Login is the first step now, not the last. The acknowledgement number
            and PDF are captured here, and the application then drops into the
            form-fill queue to be filled and printed.
          */}
          {applicationData?.status === "IN_PROGRESS" && (
            <div className=" flex gap-1">
              <AuthHOC
                forApplicationStatus={true}
                applicationName="PAN"
                applicationStatus="FORM_FILL_PENDING"
              >
                <ATMLoadingButton
                  onClick={() => {
                    setPanIdVerfiy(panApplicationId || " ");
                    setIsOpenVerifyDialog(true);
                  }}
                  loadingText="Please wait..."
                  className="px-3 py-3 rounded bg-green-500 text-white text-[12px] font-medium w-48 "
                >
                  VERIFY
                </ATMLoadingButton>
              </AuthHOC>
              {/*
                The only place an application can be rejected. Once it is
                verified it has been logged in with the department, so the
                later stages (FORM_FILL_PENDING / FORM_FILL_IN_PROGRESS) carry
                no REJECT — the application can only move forward from there.
              */}
              <AuthHOC
                forApplicationStatus={true}
                applicationName="PAN"
                applicationStatus="REJECT"
              >
                <ATMLoadingButton
                  onClick={() => {
                    setPanIdReject(panApplicationId || " ");
                    setIsOpenRejectionDialog(true);
                  }}
                  loadingText="Please wait..."
                  className="px-3 py-3 rounded bg-red-500 text-white text-[12px] font-medium w-48"
                >
                  REJECT
                </ATMLoadingButton>
              </AuthHOC>
            </div>
          )}

          {applicationData?.status === "FORM_FILL_PENDING" && (
            <div className=" flex gap-1 items-center">
              <AuthHOC
                forApplicationStatus={true}
                applicationName="PAN"
                applicationStatus="FORM_FILL_IN_PROGRESS"
              >
                <ATMLoadingButton
                  onClick={() =>
                    moveToStatus(
                      "FORM_FILL_IN_PROGRESS",
                      "Are you sure want to start Form Fill for this application ?",
                      "/pan/FORM_FILL_PENDING"
                    )
                  }
                  loadingText="Please wait..."
                  className="px-3 py-3 rounded bg-status-formfillprogress text-white text-[12px] font-medium w-48 "
                >
                  START FORM FILL
                </ATMLoadingButton>
              </AuthHOC>

              {/*
                The bypass, behind two locks. The checkbox is gated on the
                SKIP_FORM_FILL module action rather than on a status, because "may
                send an application to print without filling the form" is a
                different grant from "may fill the form" — the API enforces the
                same split on /pan-app/skip-form-fill. The button appears only
                once the box is ticked, so it cannot be hit by reflex on the way
                to START FORM FILL.
              */}
              <AuthHOC
                moduleName="PAN_APPLICATIONS"
                action={AccessAction.SKIP_FORM_FILL}
              >
                <div className="flex items-center gap-2 pl-2">
                  <label className="flex items-center gap-1.5 text-[12px] text-slate-600 cursor-pointer select-none">
                    <input
                      type="checkbox"
                      checked={isSkippingFormFill}
                      onChange={(e) => setIsSkippingFormFill(e.target.checked)}
                      className="cursor-pointer"
                    />
                    Skip form fill
                  </label>

                  {isSkippingFormFill && (
                    <ATMLoadingButton
                      onClick={() =>
                        showConfirmationDialog({
                          title: "Heads Up",
                          text: "Skip the PAN form and send this application straight for printing ?",
                          icon: "question",
                          showCancelButton: true,
                          next: (result) => {
                            if (result.isConfirmed) {
                              // Plain JSON, not FormData: the bypass carries no
                              // file, and the API route has no multipart parser.
                              skipFormFill({
                                id: panApplicationId || "",
                                body: { requestedStatus: "GENERATE" },
                              }).then((res: any) => {
                                if (res.error) {
                                  showToast("error", res.error.data?.message);
                                } else if (res.data?.status) {
                                  showToast("success", res.data?.message);
                                  setIsSkippingFormFill(false);
                                  navigate("/pan/FORM_FILL_PENDING");
                                } else {
                                  showToast("error", res.data?.message);
                                }
                              });
                            }
                          },
                        })
                      }
                      loadingText="Please wait..."
                      className="px-3 py-3 rounded bg-amber-500 text-white text-[12px] font-medium w-32 "
                    >
                      SKIP
                    </ATMLoadingButton>
                  )}
                </div>
              </AuthHOC>
            </div>
          )}

          {applicationData?.status === "FORM_FILL_IN_PROGRESS" && (
            <div className=" flex gap-1">
              {/*
                The central action of this stage, and the only place the PAN form
                is reachable. Submitting it generates the PDF and moves the
                application to GENERATE, so there is no separate "send on" button.
                Once a PDF exists the same button hands it over instead of
                reopening the form — that is what the old Download PAN Form button
                did, folded in here so there is one thing to click.
              */}
              {/*
                Gated on DOWNLOAD_PAN_FORM, which is the action the API already
                requires for POST /pan-form/add — the call this button leads to.
                Gating it on GENERATE status access instead would make the
                form-fill operator ask for a permission they use nowhere else.
              */}
              <AuthHOC
                moduleName="PAN_APPLICATIONS"
                action={AccessAction.DOWNLOAD_PAN_FORM}
              >
                <ATMLoadingButton
                  onClick={() => {
                    const existing =
                      panFormData?.data?.panFormFile ||
                      applicationData?.panFormFile;
                    if (existing) {
                      downloadPanForm(existing);
                    } else {
                      openPanFormWindow();
                    }
                  }}
                  loadingText="Please wait..."
                  className="px-3 py-3 rounded bg-status-formfillprogress text-white text-[12px] font-medium w-48 "
                >
                  FILL PAN FORM
                </ATMLoadingButton>
              </AuthHOC>
            </div>
          )}

          {/*
            REFILL PAN FORM: reopen the generated form with its saved values to
            correct it, and generate it again — the new PDF becomes the one
            everybody downloads, the old one is kept (Old PAN Forms), and the
            application's status does not move. Only roles given REFILL_PAN_FORM
            see this; the API refuses a refill from any other role. Offered on
            FORM_FILL_IN_PROGRESS and every status after it, DONE included.
          */}
          {["FORM_FILL_IN_PROGRESS", "VERIFY", "GENERATE", "DONE"].includes(
            applicationData?.status
          ) &&
            generatedPanForm && (
              <AuthHOC
                moduleName="PAN_APPLICATIONS"
                action={AccessAction.REFILL_PAN_FORM}
              >
                <ATMLoadingButton
                  onClick={() => {
                    /*
                      The form type can be changed for the refill. It opens on
                      the type the form was last generated as (else the
                      application's). Only the PDF changes type — the
                      application record keeps its own.
                    */
                    const currentType =
                      (panFormData?.data?.applicationType ||
                        applicationData?.applicationType) === "CORRECTION"
                        ? "CORRECTION"
                        : "NEW";
                    Swal.fire({
                      title: "Refill PAN Form",
                      text: "The form opens with its saved details. Generating it again creates a new PAN form PDF; the old one is kept in Old PAN Forms. Choose the application type:",
                      icon: "question",
                      input: "select",
                      inputOptions: {
                        NEW: "New (Form 49A)",
                        CORRECTION: "Correction",
                      },
                      inputValue: currentType,
                      showCancelButton: true,
                      confirmButtonColor: "#3085d6",
                      cancelButtonColor: "#d33",
                      confirmButtonText: "Continue",
                    }).then((result) => {
                      if (!result.isConfirmed) return;
                      openPanFormWindow(
                        true,
                        result.value === "CORRECTION" ? "CORRECTION" : "NEW"
                      );
                    });
                  }}
                  className="px-3 py-3 rounded bg-status-formfillprogress text-white text-[12px] font-medium w-48 "
                >
                  REFILL PAN FORM
                </ATMLoadingButton>
              </AuthHOC>
            )}

          {applicationData?.status === "GENERATE" && (
            <AuthHOC
              forApplicationStatus={true}
              applicationName="PAN"
              applicationStatus="DONE"
            >
              <ATMLoadingButton
                onClick={() =>
                  showConfirmationDialog({
                    title: "Heads Up",
                    text: "Are you sure want to Done ?",
                    icon: "question",
                    showCancelButton: true,
                    next: (result) => {
                      if (result.isConfirmed) {
                        const formData = new FormData();
                        formData.append("requestedStatus", "DONE");

                        changeStatus({
                          id: panApplicationId || "",
                          body: formData,
                        }).then((res: any) => {
                          if (res.error) {
                            showToast("error", res.error.data?.message);
                          } else {
                            if (res.data?.status) {
                              showToast("success", res.data?.message);
                              navigate("/pan/GENERATE");
                            } else {
                              showToast("error", res.data?.message);
                            }
                          }
                        });
                      }
                    },
                  })
                }
                loadingText="Please wait..."
                className="px-3 py-3 rounded bg-status-done text-white text-[12px] font-medium w-48"
              >
                DONE
              </ATMLoadingButton>
            </AuthHOC>
          )}
        </div>
      </div>

      {/* Download Buttons */}

      {/*
        Two certificate buttons sit bottom-left and the two form/zip buttons
        bottom-right, so the sticky VERIFY / REJECT / DONE buttons in the middle
        stay clear. The bar spans the full width, hence `pointer-events-none`
        on it — otherwise its empty middle would swallow clicks meant for the
        action buttons underneath. Each group re-enables pointer events.
      */}
      <div className="2xl:absolute xl:absolute lg:absolute md:absolute inset-x-3 bottom-2 flex flex-wrap items-end justify-between gap-3 pointer-events-none">
        <div className="flex flex-wrap gap-3 pointer-events-auto">
          {/*
            DSA and PCO (167) both get an Employer Certificate, generated
            automatically when the PAN form is submitted. Submitting can park the
            application in LOGIN DONE (VERIFY), so the certificate is reachable
            from there on too. With no certificate saved yet (e.g. the automatic
            one failed) the button opens the generate dialog instead.
          */}
          {applicationData &&
            ["VERIFY", "GENERATE", "DONE"].includes(applicationData.status) &&
            isEmployerCertificateCategory(applicationData.baseCatAppied) && (
              <AuthHOC
                moduleName="PAN_APPLICATIONS"
                action={AccessAction.DOWNLOAD_EMPLOYER_CERTIFICATE}
              >
                <ATMLoadingButton
                  loadingText="Downloading..."
                  onClick={() => {
                    if (rowData?.employercertificatesData?.status) {
                      handleDownload();
                    } else {
                      setIsOpenDownloadDialog(true);
                    }
                  }}
                >
                  <div className="flex items-center gap-2">
                    <TbFileDownload className="text-xl animate-bounce" />
                    <span>Download EMP Certificate</span>
                  </div>
                </ATMLoadingButton>
              </AuthHOC>
            )}

          {applicationData &&
            ["DONE", "GENERATE"].includes(applicationData.status) &&
            applicationData.dobProofType === "AFFIDAVIT (CATEGORY 03 ₹100)" && (
              <AuthHOC
                moduleName="PAN_APPLICATIONS"
                action={AccessAction.DOWNLOAD_EMPLOYER_CERTIFICATE}
              >
                <ATMLoadingButton
                  loadingText="Downloading..."
                  onClick={() => {
                    if (affidavitRowData?.affidavitcertificatesData?.status) {
                      handleAffidavitDownload();
                    } else {
                      setIsAffidavitUpdate(false);
                      setIsOpenAffidavitDownloadDialog(true);
                    }
                  }}
                >
                  <div className="flex items-center gap-2">
                    <TbFileDownload className="text-xl animate-bounce" />
                    <span>Download AFFIDAVIT Certificate</span>
                  </div>
                </ATMLoadingButton>
                {/* Reopen the generated affidavit with its saved details. */}
                {affidavitRowData?.affidavitcertificatesData?.status && (
                  <ATMLoadingButton
                    className="bg-blue-600"
                    onClick={() => {
                      setIsAffidavitUpdate(true);
                      setIsOpenAffidavitDownloadDialog(true);
                    }}
                  >
                    <span>Update AFFIDAVIT</span>
                  </ATMLoadingButton>
                )}
              </AuthHOC>
            )}
        </div>

        <div className="flex flex-wrap gap-3 pointer-events-auto ml-auto">
          {/*
            A PAN form that has already been generated stays downloadable from the
            stages after form fill. While the application is still in
            FORM_FILL_IN_PROGRESS the FILL PAN FORM button above owns this action,
            so there is never a second button competing with it.
          */}
          {applicationData &&
            ["VERIFY", "GENERATE", "DONE"].includes(applicationData.status) &&
            canDownloadPanForm && (
              <AuthHOC
                moduleName="PAN_APPLICATIONS"
                action={AccessAction.DOWNLOAD_PAN_FORM}
              >
                <ATMLoadingButton
                  loadingText="Downloading..."
                  onClick={() => downloadPanForm(generatedPanForm)}
                >
                  <div className="flex items-center gap-2">
                    <TbFileDownload className="text-xl animate-bounce" />
                    {/* A refilled form is the corrected one; the replaced
                        PDFs are under Old PAN Forms. */}
                    <span>
                      {(panFormData?.data?.refillCount || 0) > 0
                        ? "Updated PAN Form"
                        : "Download PAN Form"}
                    </span>
                  </div>
                </ATMLoadingButton>
              </AuthHOC>
            )}

          {/*
            Earlier PAN form PDFs that refills replaced. Everyone else only gets
            the latest form above; this is for roles given VIEW_OLD_PAN_FORM.
          */}
          {generatedPanForm && (panFormData?.data?.refillCount || 0) > 0 && (
            <AuthHOC
              moduleName="PAN_APPLICATIONS"
              action={AccessAction.VIEW_OLD_PAN_FORM}
            >
              <ATMLoadingButton onClick={() => setIsOpenOldPanForms(true)}>
                <div className="flex items-center gap-2">
                  <TbFileDownload className="text-xl" />
                  <span>Old PAN Forms</span>
                </div>
              </ATMLoadingButton>
            </AuthHOC>
          )}

          <AuthHOC moduleName="PAN_APPLICATIONS" action={AccessAction.ZIP}>
            <ATMLoadingButton
              isLoading={isZipDownloading}
              loadingText="Downloading..."
              onClick={() => handleDownloadZip(applicationData?.srn)}
            >
              <div className="flex gap-2 items-center">
                <TbFileDownload className="text-xl animate-bounce" /> Download
                Zip
              </div>
            </ATMLoadingButton>
          </AuthHOC>
        </div>
      </div>

      {isOpenOldPanForms && applicationData?._id && (
        <OldPanFormsDialog
          panId={applicationData._id}
          onClose={() => setIsOpenOldPanForms(false)}
          onDownload={(url, index) =>
            downloadNamed(url, `PAN_Form_Old_${index}`, "pdf")
          }
        />
      )}

      {isOpenAOCodeDialog && (
        <AOCodeListDialogWrapper onClose={() => setIsOpenAOCodeDialog(false)} />
      )}
      {isOpenVerifyDialog && (
        <ApplicationVerifyDialogWrapper
          type="PAN"
          category = {applicationData?.baseCatAppied}
          dobProofType={applicationData?.dobProofType}
          paymentCategory={applicationData?.paymentCategory}
          /*
            Decides whether the AO Code is asked for: a correction is filed
            against an existing PAN, so it has no Part D to pre-fill and no code
            to ask for.
          */
          applicationType={applicationData?.applicationType}
          title="Verify Application"
          /*
            PAN captures the acknowledgement number at the front of the flow, so
            this dialog lands the application in the form-fill queue rather than
            on VERIFY. Every other service still posts VERIFY.
          */
          requestedStatus="FORM_FILL_PENDING"
          onClose={() => setIsOpenVerifyDialog(false)}
          onSubmit={(formData) =>
            changeStatus({ id: panIdVerfiy || "", body: formData }).then(
              (res: any) => {
                if (res?.error) {
                  showToast("error", res?.error?.data?.message);
                } else {
                  if (res?.data?.status) {
                    showToast("success", res?.data?.message);
                    /*
                      Back to the Pending queue, which is where this landed
                      before the flow reorder moved it to In Progress. That is
                      the operator's home list: finish one application, return
                      to the top of the pile and take the next.

                      The application itself is in FORM_FILL_PENDING by now, so
                      it is deliberately not in the list you land on - it has
                      moved on to the form-fill operator.
                    */
                    navigate("/pan/PENDING");
                  } else {
                    showToast("error", res?.data?.message);
                  }
                }
                return res;
              }
            )
          }
        />
      )}

      {isOpenRejectionDialog && (
        <ApplicationRejectionDialogWrapper
          onClose={() => setIsOpenRejectionDialog(false)}
          onSubmit={(formData) =>
            changeStatus({ id: panIdReject || "", body: formData }).then(
              (res: any) => {
                if (res?.error) {
                  showToast("error", res?.error?.data?.message);
                } else {
                  if (res?.data?.status) {
                    showToast("success", res?.data?.message);
                    navigate("/pan/PENDING");
                  } else {
                    showToast("error", res?.data?.message);
                  }
                }
              }
            )
          }
        />
      )}


       {isOpenDonwloadDialog && (
              <DownloadDialogWrapper
                onClose={() => setIsOpenDownloadDialog(false)}
                businessEnquiryData={rowData}
              />
        )}

       {isOpenAffidavitDownloadDialog && (
              <AffidavitDownloadDialogWrapper
                onClose={() => setIsOpenAffidavitDownloadDialog(false)}
                businessEnquiryData={affidavitRowData}
                isUpdate={isAffidavitUpdate}
                // The new file URL / status for the Download button above.
                onGenerated={() =>
                  applicationData?._id &&
                  getAffidavitCertificateById(applicationData._id)
                }
              />
        )}


    </div>
    
  );
};

export default ViewPanCardApplication;
